import React from "react";
import { Box, Paper, Typography } from "@mui/material";

interface JsonPreviewProps {
  json: string;
  label?: string;
  maxHeight?: number;
}

const JsonPreview: React.FC<JsonPreviewProps> = ({
  json,
  label = "JSON Preview",
  maxHeight = 300,
}) => {
  let formatted = json;
  try {
    formatted = JSON.stringify(JSON.parse(json), null, 2);
  } catch {
    // keep raw string if invalid
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        bgcolor: "grey.50",
        maxHeight,
        overflow: "auto",
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: "block" }}>
        {label}
      </Typography>
      <Box
        component="pre"
        sx={{
          margin: 0,
          fontFamily: "monospace",
          fontSize: "0.75rem",
          lineHeight: 1.5,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {formatted || "{}"}
      </Box>
    </Paper>
  );
};

export default JsonPreview;
